import GenericService from "./GenericService";
import jwtDecode from "jwt-decode";

class UserService extends GenericService {
  login = (username, password) =>
    new Promise((resolve, reject) => {
      this.post("login", { username, password })
        .then(({ token }) => {
          if (token) {
            localStorage.setItem("token", token);
          }
          resolve(token);
        })
        .catch((err) => {
          reject(err);
        });
    });
  isLoggedIn = () => {
    const token = localStorage.getItem("token");
    return token ? true : false;
  };
  getUserToken = () => {
    try {
      const jwt = localStorage.getItem("token");
      return jwtDecode(jwt);
    } catch (ex) {
      return null;
    }
  };
  getLoggedInUser = () => {
    let user = localStorage.getItem("benefitPlan");
    if (user) {
      user = JSON.parse(user);
    }
    return user;
  };

  getAccess = () => JSON.parse(localStorage.getItem("access"));
}

let userService = new UserService();
export default userService;
